/* eslint-disable max-len */
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  RAKEZ_FETCH_DATA_REQUEST,
  setRakezData,
  setRakezDataLoading,
  setRakezError
} from "../actions/rakezData";
import { log } from "../../utils/loggger";
import { prospect } from "../../api/apiClient";
import { getAuthorizationHeader } from "../selectors/appConfig";
import { setScreeningError } from "../actions/sendProspectToAPI";

import {
  APP_STOP_SCREEN_RESULT,
  SCREENING_FAIL_REASONS,
  screeningStatus,
  screeningStatusDefault,
  TL_STAKEHOLDER_COUNT_CHECK_ERROR
} from "../../constants";
import { updateProspect } from "../actions/appConfig";

export function* showScreeningError(screeningResults) {
  const currScreeningType = screeningResults.find(
    screeningResult =>
      screeningResult.screeningNotes &&
      SCREENING_FAIL_REASONS.includes(screeningResult.screeningReason)
  );
  const normalizeScreeningType = value =>
    typeof value === "string" || typeof value === "number"
      ? String(value)
          .trim()
          .toLowerCase()
      : "";
  const currentScreeningType = normalizeScreeningType(currScreeningType?.screeningType);
  const screenError = currentScreeningType
    ? screeningStatus.find(
        ({ screeningType }) => normalizeScreeningType(screeningType) === currentScreeningType
      )
    : undefined;
  const buttons = [
    {
      external: true,
      link: `${process.env.REACT_APP_BAU_URL}/business/applicantinfo-redirect`,
      label: "Continue"
    }
  ];

  if (screenError) {
    yield put(
      setScreeningError({
        ...screenError,
        text: currScreeningType?.reasonNotes || TL_STAKEHOLDER_COUNT_CHECK_ERROR,
        icon: "",
        isEFRDeclinedScreen: false,
        redirectToBAU: true,
        buttons
      })
    );
  } else {
    yield put(
      setScreeningError({
        ...screeningStatusDefault,
        text: currScreeningType?.reasonNotes || screeningStatusDefault.text
      })
    );
  }
}

export function* fetchRakezData({ payload: { prospectId, licenseNo, licenseIssuingAuthority } }) {
  try {
    yield put(setRakezDataLoading(true));
    const authHeader = yield select(getAuthorizationHeader);
    const headers = {
      headers: {
        ...authHeader.headers
      }
    };
    const tlNo = licenseNo || "";
    const tlAuth = licenseIssuingAuthority || "";
    const {
      data: { organizationInfo, partnersDetailInfo, tlAuthorityInfo }
    } = yield call(prospect.get, prospectId, headers, "", tlNo, tlAuth);
    const { screeningInfo } = organizationInfo;
    const isScreeningError = screeningInfo?.statusOverAll === APP_STOP_SCREEN_RESULT;
    if (isScreeningError) {
      yield call(showScreeningError, screeningInfo.screeningResults);
    }
    const tlAuthority = JSON.parse(tlAuthorityInfo);
    const tlAuthorityData = tlAuthority?.data;

    if (tlAuthorityData === undefined || tlAuthorityData === null) {
      const errorMessage =
        licenseIssuingAuthority === "RAKEZ"
          ? tlAuthority?.errors?.[0]?.message
          : tlAuthority?.tlStatusDescription;
      throw new Error(errorMessage || "Failed to fetch Rakez data");
    }

    yield put(setRakezData(tlAuthorityData || {}, tlAuthority));
    yield put(
      updateProspect({
        "prospect.partnersDetailInfo": partnersDetailInfo || null
      })
    );
  } catch (error) {
    yield put(setRakezDataLoading(false));
    yield put(setRakezError("rakezError", error));
    log(error);
  }
}

export default function* tlAuthorityInfoSaga() {
  yield all([takeLatest(RAKEZ_FETCH_DATA_REQUEST, fetchRakezData)]);
}
